module.exports = __webpack_public_path__ + "static/img/tm-4.f659216.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/tm-4.jpg
// module id = tO21
// module chunks = 0